import { Element, Text } from "slate";
import { ElementUtils } from "../../slate/utils/element";
import { richTextV2DescendentsToData } from "./dto";
function copyRichTextV2Data(data, context) {
  if (data == null)
    return data;
  return richTextV2DescendentsToData(data.descendants?.flatMap((d) => copyNode(d)));
  function copyNode(descendant) {
    if (Element.isElement(descendant) && ElementUtils.isInline(descendant)) {
      return copyLinkData(descendant);
    }
    if (Text.isText(descendant)) {
      return copyTypographyData(descendant);
    }
    return { ...descendant, children: descendant.children.map(copyNode) };
  }
  function copyLinkData(descendant) {
    if (descendant.type !== "link") {
      return { ...descendant, children: descendant.children.map(copyNode) };
    }
    if (descendant.link == null)
      return descendant;
    switch (descendant.link.type) {
      case "OPEN_PAGE": {
        const pageId = descendant.link.payload.pageId;
        if (pageId == null)
          return descendant;
        return {
          ...descendant,
          link: {
            ...descendant.link,
            payload: {
              ...descendant.link.payload,
              pageId: context.replacementContext.pageIds.get(pageId) ?? descendant.link.payload.pageId
            }
          },
          children: descendant.children.map(copyNode)
        };
      }
      case "SCROLL_TO_ELEMENT": {
        const elementIdConfig = descendant.link.payload.elementIdConfig;
        if (elementIdConfig == null)
          return descendant;
        return {
          ...descendant,
          link: {
            ...descendant.link,
            payload: {
              ...descendant.link.payload,
              elementIdConfig: {
                ...elementIdConfig,
                elementKey: context.replacementContext.elementKeys.get(elementIdConfig.elementKey) ?? elementIdConfig.elementKey
              }
            }
          },
          children: descendant.children.map(copyNode)
        };
      }
      default:
        return descendant;
    }
  }
  function copyTypographyData(descendant) {
    return {
      ...descendant,
      ...descendant.typography == null ? {} : {
        typography: {
          id: context.replacementContext.typographyIds.get(descendant.typography?.id ?? "") ?? descendant.typography?.id,
          style: descendant.typography?.style.map((override) => ({
            ...override,
            value: {
              ...override.value,
              ...override.value.color == null ? {} : {
                color: {
                  ...override.value.color,
                  swatchId: context.replacementContext.swatchIds.get(
                    override.value.color?.swatchId ?? ""
                  ) ?? override.value.color?.swatchId
                }
              }
            }
          }))
        }
      }
    };
  }
}
export {
  copyRichTextV2Data
};
//# sourceMappingURL=copy.js.map